/**
 * @method getBooleanFromEnvVariable
 * @description Gets a boolean value from an evironment variable
 * @param {string} name
 */
export function getBooleanFromEnvVariable(name) {
  if (process.env[name] === "true") return true;

  return false;
}

export const convivaTraceLogs = getBooleanFromEnvVariable("REACT_APP_CONVIVA_TRACE_LOGS");
export const forgeRockAuthString = window.btoa(process.env.REACT_APP_FORGE_ROCK_AUTH_STRING);
export const isBrazil = getBooleanFromEnvVariable("REACT_APP_BRAZIL");
export const isLocalLoginEnabled = getBooleanFromEnvVariable("REACT_APP_ENABLE_LOCAL_LOGIN");
export const isProduction = getBooleanFromEnvVariable("REACT_APP_IS_PRODUCTION_ENV");
export const isTouchstoneEnabled = getBooleanFromEnvVariable("REACT_APP_CONVIVA_TOUCHSTONE_ENABLED");
